module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('profile.password.title')
    }
  }, [(!_vm.changed) ? [_c('v-alert', {
    attrs: {
      "error": "",
      "value": _vm.invalid
    }
  }, [_vm._v(_vm._s(_vm.$t('reset.invalidToken')))]), _vm._v(" "), (!_vm.invalid) ? _c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "only-hide": ""
    }
  }, [_c('password-form', {
    attrs: {
      "error": _vm.error,
      "complexity": _vm.passwordComplexity
    },
    on: {
      "save": _vm.save
    }
  })], 1) : _vm._e()] : [_c('v-alert', {
    attrs: {
      "success": "",
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.$t('reset.success')))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('reset.continue')))])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-148a46da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PasswordReset.vue
// module id = 1054
// module chunks = 1